var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isWechat)?_c('legacy-wechat-shop-board-detail',{attrs:{"embedded":""}}):_c('legacy-shop-board-detail',{attrs:{"embedded":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }